import { render, staticRenderFns } from "./GrupopcionForm.vue?vue&type=template&id=922cf58c&"
import script from "./GrupopcionForm.vue?vue&type=script&lang=js&"
export * from "./GrupopcionForm.vue?vue&type=script&lang=js&"
import style0 from "./GrupopcionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports